import * as React from 'react';
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { CategoryHotels } from '../core/CategoryHotels';
import { getHotelSlug, makeid } from '../core/Const';
import { ModalWrapper } from '../core/index';
import { HotelBedCatalogData } from 'src/shared';
import Tooltip from 'rc-tooltip';
export interface BookingHotelPanelProps extends BaseComponentProps {
    hotelData: HotelBedCatalogData.Hotel;
    lang: string;
}

export interface BookingHotelPanelState extends BaseComponentState {
    isOpen: boolean;
    hotelDesriptionClass: string;
    btnClickNoteText: string;
    tripmodelOpen: boolean;
}

export class BookingHotelPanel extends BaseComponent<BookingHotelPanelProps, BookingHotelPanelState> {

    constructor(props: BookingHotelPanelProps) {
        super(props);
        this.state = {
            isOpen: false,
            hotelDesriptionClass: 'short-description',
            btnClickNoteText: 'Read More',
            tripmodelOpen: false
        };
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let hotelData = this.props.hotelData;
        let style: ReactModal.Styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0, 0.75)',
                zIndex: 9999
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: 'rgba(0,0,0,0)',
                border: 0
            }
        };
        var settings = {
            dots: false,
            infinite: true,
            speed: 1500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            pauseOnHover: true,
        };
        let slide: any[] = [];
        let x = 1;
        if ((this.props.hotelData && this.props.hotelData.HotelImageSumaryData)) {
            for (let a of this.props.hotelData.HotelImageSumaryData!) {
                slide.push(
                    <div>
                        <div
                            key={x}
                            style={
                                { 
                                    width: '100%', 
                                    height: '35vw', 
                                    margin: '.25vw auto', 
                                    backgroundImage: `url("${a.path}")`, 
                                    backgroundSize: 'cover', 
                                    backgroundPosition: 'center',
                                    fontSize: '3px'
                                }
                            }
                        >https://www.balihotelsandmore.com
                        </div>
                    </div>
                );
                x++;
            }
        }
        let ttl: string = '';
        if (window.location.hostname.indexOf('localhost') >= 0) {
            ttl = `internal dev only : ${this.props.hotelData.code} `;
        }
        let hotelPhones = [];
        if ((this.props.hotelData.phones)) {
            for (let a of this.props.hotelData.phones!) {
                if (a.phoneType === 'FAXNUMBER') {
                    hotelPhones.push(
                        <span key={makeid()} > <i className="fa fa-fax" /> {a.phoneNumber} </span>
                    );
                } else if (a.phoneType === 'PHONEBOOKING') {
                    hotelPhones.push(
                        <span key={makeid()} > <i className="fa fa-headphones" /> {a.phoneNumber} </span>
                    );
                } else {
                    hotelPhones.push(
                        <span key={makeid()} > <i className='fa fa-phone' /> {a.phoneNumber}  </span>
                    );
                }
            }
        } 
        let isiToolTip = [];
        let tripadvisor: any = <span/>;
        if (this.props.hotelData.TripAdvisorData) {
            if ((this.props.hotelData.TripAdvisorData!) && (this.props.hotelData.TripAdvisorData!.subratings) && this.props.hotelData.TripAdvisorData!.subratings!.length > 0) {
                for (let subrating of this.props.hotelData.TripAdvisorData!.subratings!) {
                    isiToolTip.push(
                        <p key={makeid()} >{subrating.localized_name} :  <img src={subrating.rating_image_url} /> </p>
                    );
                }
            }
            let rangked: any = '';
            if (this.props.hotelData.TripAdvisorData! && (this.props.hotelData.TripAdvisorData!.ranking_data!) && (this.props.hotelData.TripAdvisorData!.ranking_data.ranking_string)) {
                rangked = this.props.hotelData.TripAdvisorData!.ranking_data.ranking_string;
            }
            tripadvisor = (
                <div>
                    <p key={1}>
                        <Tooltip
                            placement='bottom'
                            overlay={<div style={{ minHeight: 50, minWidth: 50 }}> {isiToolTip} </div>}
                        >
                            <a
                                onClick={
                                    () => {
                                        this.setState({ tripmodelOpen: true });
                                    }
                                }
                            >
                                TripAdvisor Traveller Rating<br />
                                <img src={this.props.hotelData.TripAdvisorData!.rating_image_url ? this.props.hotelData.TripAdvisorData!.rating_image_url!.split('http:').join('https:') : ''} style={{ width: 100 }} /> <span style={{ fontSize: 10 }}>Base on {this.props.hotelData.TripAdvisorData!.num_reviews} reviews </span>
                            </a>
                        </Tooltip>
                    </p>
                    <p key={2}>
                        <span className="btn-purple" style={{ padding: '2px 5px' }}>
                            Ranked : {rangked}
                        </span>
                    </p>
                </div>
            );
        }
        
        return (
            <div className={`col-md-12 row nopadding hotel-list`} title={ttl}>
                <div className="col-md-4 nopadding">
                    <div
                        style={{ height: '250px', backgroundImage: `url("${this.props.hotelData.thumbUrl}")`, backgroundPosition: 'center' }}
                        className="hotel-image"
                        onClick={() => {
                            this.setStateHelper(st => st.isOpen = true);
                        }}
                    />
                </div>
                <div className="col-md-8" style={{ margin: '10px 0' }}>
                    <h4> <NavLink to={`/${getHotelSlug(hotelData.name!, hotelData.code!)}`}> {hotelData.name} <i className='fa fa-info-circle' /> </NavLink> <CategoryHotels star={this.props.hotelData.Category!.simpleCode!} /> </h4>
                    <div>
                        <a key={'loc'} href={`https://www.google.com/maps/?q=${hotelData.coordinates_latitude},${hotelData.coordinates_longitude}`} target="_blank" style={{ float: 'right' }}>
                            <i className="fa fa-map-marker" />{` ${hotelData.location}`} - View on map
                        </a>
                        <p>
                            {hotelData.address}
                        </p>
                        {tripadvisor}
                         
                        <p className={this.state.hotelDesriptionClass}>
                            {hotelData.description}
                        </p>

                        <a
                            onClick={
                                () => {
                                    this.setStateHelper(
                                        (st: any) => {
                                            if (st.hotelDesriptionClass === 'short-description') {
                                                st.hotelDesriptionClass = 'long-description';
                                                st.btnClickNoteText = 'Read Less';
                                            } else {
                                                st.hotelDesriptionClass = 'short-description';
                                                st.btnClickNoteText = 'Read More';
                                            }
                                        });
                                }}
                        > {this.state.btnClickNoteText}
                        </a>
                        <a className="btn   btn-warning btn-xs" style={{backgroundColor: "#ff5800", display: 'block', borderColor: "#ff5800", fontWeight: 800}} target="_blank" href="https://wa.me/+6287860006919&text=Hallo%20Bali%20hotels">Need Help? We Live In Bali! Click Here For Help.  </a>
                    </div>
                </div>
                <ModalWrapper
                    style={style}
                    isOpen={this.state.isOpen}
                    onRequestClose={this.hengleUserDialogClose}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                >
                    <div style={{ maxWidth: 800 }}>
                    <button className="btnClose" onClick={this.hengleUserDialogClose}><i className="ti-close" /></button>
                        <Slider {...settings}>
                            {slide}
                        </Slider>
                    </div>
                </ModalWrapper>
            </div>
        );
    }
    hengleUserDialogClose: () => any = () => {
        this.setState({ isOpen: false });
    }
}


// WEBPACK FOOTER //
// ./src/new-booking/BookingHotelPanel.tsx